import React from 'react';

import CountryInfo from '../CountryInfo';

const KFW_SECTION = {
    title: 'KfW Kredite für Unternehmen',
    content: (
        <div>
            <p>
                Als Unternehmen, Selbstständiger oder Freiberufler sind Sie
                durch die Corona-Krise in finanzielle Schieflage geraten und
                benötigen einen Kredit?
            </p>
            <br />
            <p>
                Um Ihre Liquidität zu verbessern und laufende Kosten zu decken,
                können Sie jetzt einen KfW-Kredit erhalten. Den Kredit
                beantragen Sie bei Ihrer Bank oder Sparkasse.
            </p>
            <br />
            <p>
                Bereiten Sie jetzt Ihren Antrag vor – damit Ihr Bankgespräch
                schneller zum Ziel führt.
            </p>
        </div>
    ),
    links: [
        {
            title: 'KfW-Corona-Hilfe: Kredite für Unternehmen',
            url: 'https://www.kfw.de/KfW-Konzern/Newsroom/Aktuelles/KfW-Corona-Hilfe-Unternehmen.html',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Germany',
    lastUpdated: 'March 27, 2020',
    introSection: (
        <p>Germany has announced a stimulus package of $610 billion.</p>
    ),
    sections: [KFW_SECTION],
};

const GermanyInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default GermanyInfo;
